module.exports = __webpack_public_path__ + "files/53db2c7f301604734eeb1899b47e47e8.png";